var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_c('router-view'),_c('div',{attrs:{"id":"fb-root"}}),_c('div',{staticClass:"fb-customerchat",attrs:{"attribution":"setup_tool","page_id":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }